import { isDefined } from './helpers';
import Splide from '@splidejs/splide';

export function initActualites() {
    sliderActualites();
}

function sliderActualites()
{
    const slider = document.querySelector('.actualites-slider');
    const buttons = document.querySelectorAll('.slider-button-actualites');

    if(!isDefined(slider)) return;

    // count the number of slides
    $config = {
        speed : "1500",   
        interval : "3000",
        pagination:false,
        autoplay: true,
        waitForTransition: false,
        pauseOnHover: true,
        pauseOnFocus: false,
        updateOnMove: true,
        arrows: false,
        perPage: 3,
        focus: 'center',
        gap: 70,
        mediaQuery: 'max',
        breakpoints: {
            1190: {
                perPage: 2,
                gap: 80,
            },
            800: 
            {
                perPage: 1,
            }
        }
    }

    const slides = slider.querySelectorAll('.splide__slide');
    if(isDefined(slides) && slides.length > 1)
    {
        $config.type = "loop";
    }
    else
    {
        $config.type = "slide";
    }

    let sliderActualites = new Splide( slider, $config);

    sliderActualites.mount();

    if(isDefined(buttons))
    {
        buttons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                if(button.classList.contains('right'))
                {
                    sliderActualites.go('>');
                }
                else
                {
                    sliderActualites.go('<');
                }
            });
        });
    }
}
